import { render, staticRenderFns } from "./preparation-steps.vue?vue&type=template&id=708d4118&"
import script from "./preparation-steps.vue?vue&type=script&lang=js&"
export * from "./preparation-steps.vue?vue&type=script&lang=js&"
import style0 from "./preparation-steps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookingTerminalCard: require('/opt/cargo.front/src/components/booking/terminal-card.vue').default})
